<template>
    <v-combobox
        ref="combobox_1"
        v-model="hospClin"
        :readonly="disableElements"
        :disabled="loading.to.hospital || loading.to.doctor"
        clearable
        prefix="DR."
        color="teal"
        label="Full Name of Doctor"
        :items="getToDoctors"
        return-object
        item-text="doc_name"
        autocomplete="nope"
        :loading="loading.to.hospital || loading.to.doctor"
        @change="handleChangeHospClinDoctor($event)"
    >
        <template #item="{ item }">
            <v-list-item-content>
                <v-list-item-title style="color: black;">
                    {{ item.doc_name }}
                </v-list-item-title>
                <v-list-item-subtitle style="font-size: 12px">
                    {{
                        [
                            item.doc_specialization_1,
                            item.doc_specialization_2,
                            item.doc_specialization_3
                        ]
                            .filter(Boolean)
                            .join(' • ')
                    }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </template>
    </v-combobox>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    props: ['to', 'disableElements', 'loading'],
    data: ()=>({
        hospClin: null,
        rules: {
            doctorRules: [v => !!v || 'This field is required!', v => v != null && /^[A-z|0-9]+/.test(v.trim()) || 'Invalid input!']
        }
    }),
    computed: {
        ...mapGetters(['getToDoctors'])
    },
    watch: {
        getToDoctors() {
            this.loading.to.doctor = false
        },
        'to.hospClinDoctor': {
            handler(newVal) {
                this.hospClin = newVal
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        handleChangeHospClinDoctor(value) {
            this.to.hospClinDoctor = value && value.doc_name
            this.to.hospClinDoctorCode = value && value.doc_id
        }
    }
}
</script>
